import React, { useState, useEffect, useRef } from 'react';
import LazyBg from '../components/LazyBg';
import { useNavigate } from 'react-router-dom';
import Globals from '../Globals';
import { HashLink } from 'react-router-hash-link';
import DepartureCalculator from './DepartureCalcul';
const API=Globals.API;


function Voyage() {
 const navigate = useNavigate();
 const filterChanged = useRef(false);
 const [showSuccess, setShowSuccess] = useState(false);
 const [events, setEvents] = useState([]);
 const [loading, setLoading] = useState(true);
 const [selectedEvent, setSelectedEvent] = useState(null);
 const [showModal, setShowModal] = useState(false);
 const [searchTerm, setSearchTerm] = useState('');
 const [selectedDestinations, setSelectedDestinations] = useState([]);
 const [priceMin, setPriceMin] = useState(0);
 const [priceMax, setPriceMax] = useState(15000);
 const [destinations, setDestinations] = useState([]);

 useEffect(() => {
 const urlParams = new URLSearchParams(window.location.search);
 if (urlParams.get('success') === 'true') {
 setShowSuccess(true);
 setTimeout(() => {
 window.history.replaceState({}, '', window.location.pathname);
 setShowSuccess(false);
 }, 5000);
 }

 fetchEvents();
 }, []);

 const fetchEvents = async () => {
 try {
 const response = await fetch(`${API}/events`);
 const result = await response.json();
 
 if (result.success) {
 const voyageEvents = result.data.filter(event => event.category === 'voyage' && event.isActive);
 setEvents(voyageEvents);
 const uniqueDestinations = [...new Set(voyageEvents.map(event => event.destination))];
 setDestinations(uniqueDestinations);
 }
 } catch (error) {
 console.error('Error fetching events:', error);
 } finally {
 setLoading(false);
 }
 };

 // Helper function to get the first available departure date pricing
 const getEventPricing = (event) => {
 if (event.departureDates && event.departureDates.length > 0) {
 const firstDeparture = event.departureDates[0];
 return firstDeparture.pricing?.b2c || {};
 }
 return {};
 };

 // Helper function to get base price
 const getBasePrice = (event) => {
 const pricing = getEventPricing(event);
 return pricing.price || 0;
 };

 const openModal = (event) => {
 setSelectedEvent(event);
 setShowModal(true);
 };

 const closeModal = () => {
 setShowModal(false);
 setSelectedEvent(null);
 };

 const handleDestinationToggle = (dest) => {
 if(selectedDestinations.includes(dest)) {
 setSelectedDestinations(selectedDestinations.filter(d => d !== dest));
 } else {
 setSelectedDestinations([...selectedDestinations, dest]);
 }
 };

 const removeAccents = (str) => {
 return str ? str.normalize("NFD").replace(/[\u0300-\u036f]/g,"") :"";
 };

 useEffect(() => {
 if (!filterChanged.current) { filterChanged.current = true; return; }
 const resultsEl = document.getElementById('results-section-voyage');
 if (resultsEl) {
 const y = resultsEl.getBoundingClientRect().top + window.scrollY - 100;
 window.scrollTo({ top: y, behavior: 'smooth' });
 }
 }, [searchTerm, selectedDestinations, priceMin, priceMax]);

 const filteredEvents = events.filter(event => {
 const searchNormalized = removeAccents(searchTerm.toLowerCase());
 const titleNormalized = removeAccents(event.title.toLowerCase());
 const destNormalized = removeAccents(event.destination ? event.destination.toLowerCase() :"");
 
 const matchesSearch = titleNormalized.includes(searchNormalized) || destNormalized.includes(searchNormalized);
 const matchesDestination = selectedDestinations.length === 0 || selectedDestinations.includes(event.destination);
 const basePrice = getBasePrice(event);
 const matchesPrice = basePrice >= priceMin && basePrice <= priceMax;
 return matchesSearch && matchesDestination && matchesPrice;
 });

 return (
 <div>
 {/* Enhanced Modal */}
 {showModal && selectedEvent && (
 <div
 className="modal fade show"
 style={{ 
 display: 'block', 
 backgroundColor: 'rgba(0,0,0,0.7)',
 backdropFilter: 'blur(5px)'
 }}
 onClick={closeModal}
 >
 <div
 className="modal-dialog modal-lg modal-dialog-scrollable"
 onClick={e => e.stopPropagation()}
 style={{ maxWidth: '900px' }}
 >
 <div className="modal-content" style={{ 
 border: 'none',
 borderRadius: '20px',
 overflow: 'hidden',
 boxShadow: '0 20px 60px rgba(0,0,0,0.3)'
 }}>
 <div className="modal-header position-relative" style={{ 
 background: 'linear-gradient(135deg, #2B4C7E 0%, #567ebb 100%)',
 color: 'white',
 padding: '1.5rem',
 border: 'none'
 }}>
 <h5 className="modal-title fw-bold">{selectedEvent.title}</h5>
 <button
 type="button"
 className="btn-close btn-close-white"
 onClick={closeModal}
 style={{ opacity: 1 }}
 ></button>
 </div>
 <div className="modal-body" style={{ padding: '2rem' }}>
 <div className="position-relative mb-4" style={{ borderRadius: '15px', overflow: 'hidden' }}>
 <img
 src={selectedEvent.image}
 alt={selectedEvent.title}
 className="img-fluid w-100"
 style={{ maxHeight: '400px', objectFit: 'cover' }}
 />
 <div className="position-absolute bottom-0 start-0 w-100 p-3" style={{
 background: 'linear-gradient(to top, rgba(0,0,0,0.7), transparent)'
 }}>
 <h6 className="text-white mb-0">
 <i className="fa fa-map-marker-alt me-2"></i>
 {selectedEvent.destination}
 </h6>
 </div>
 </div>

 {/* Pricing Section with Departure Dates */}
 {selectedEvent.departureDates.map((departure, index) => {
 const pricing = departure.pricing?.b2c || {};
const isComplet =
 !departure.isAvailable || departure.availableSeats === 0;
 return (
 <div
 key={index}
 className="mb-4 p-4"
 style={{
 background:"white",
 borderRadius:"15px",
 border:"1px solid #e9ecef",
 }}
 >
 {/* Departure Header */}
 <div className="d-flex justify-content-between align-items-center mb-3">
 <div>
 <strong style={{ color:"#2B4C7E" }}>
 <i className="fa fa-plane-departure me-2"></i>
 Départ :{""}
 {new Date(departure.departureDate).toLocaleDateString("fr-FR")}
 </strong>
 <br />
 <strong style={{ color:"#2B4C7E" }}>
 <i className="fa fa-plane-arrival me-2"></i>
 Retour :{""}
 {new Date(departure.returnDate).toLocaleDateString("fr-FR")}
 </strong>
 </div>

 <span
 className={`badge ${isComplet ?"bg-danger" :"bg-success"}`}
>
 {isComplet
 ?"Complet"
 : `${departure.availableSeats} places disponibles`}
</span>

 </div>

 {/* Static Pricing Info */}
 <div className="row g-2 mb-3">
 <div className="col-md-6">
 <div className="p-2 bg-light rounded">
 <strong>Prix standard :</strong> {pricing.price ||"N/A"} TND
 </div>
 </div>

 {pricing.tarifdemidouble != null && (
 <div className="col-md-6">
 <div className="p-2 bg-light rounded">
 <strong>Demi-double :</strong> {pricing.tarifdemidouble} TND
 </div>
 </div>
 )}

 {pricing.spplementsingle != null && (
 <div className="col-md-6">
 <div className="p-2 bg-light rounded">
 <strong>Supplément single :</strong>{""}
 {pricing.spplementsingle} TND
 </div>
 </div>
 )}

 {pricing.tarif3eme != null && (
 <div className="col-md-6">
 <div className="p-2 bg-light rounded">
 <strong>3ᵉ lit :</strong> {pricing.tarif3eme} TND
 </div>
 </div>
 )}
 {pricing.bebe != null && (
 <div className="col-md-6">
 <div className="p-2 bg-light rounded">
 <strong>Bébé :</strong> {pricing.bebe} TND
 </div>
 </div>
)}


 {pricing.enf2_6 != null && (
 <div className="col-md-6">
 <div className="p-2 bg-light rounded">
 <strong>Enfant 2–6 ans :</strong> {pricing.enf2_6} TND
 </div>
 </div>
 )}

 {pricing.enf6_12 != null && (
 <div className="col-md-6">
 <div className="p-2 bg-light rounded">
 <strong>Enfant 6–12 ans :</strong> {pricing.enf6_12} TND
 </div>
 </div>
 )}
 </div>

 {/* 🔥 CALCULATOR */}
 <DepartureCalculator departure={departure} />
 </div>
 );
})}


 <div className="mb-4">
 <h5 className="fw-bold mb-3" style={{ color: '#2B4C7E' }}>
 <i className="fa fa-info-circle me-2"></i>Description
 </h5>
 <p className="text-muted" style={{ lineHeight: '1.8' }}>{selectedEvent.description}</p>
 </div>

 <div className="mb-4">
 <h5 className="fw-bold mb-3" style={{ color: '#2B4C7E' }}>
 <i className="fa fa-list-ul me-2"></i>Programme
 </h5>
 <div className="p-4" style={{ 
 background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
 borderRadius: '15px',
 borderLeft: '4px solid #2B4C7E'
 }}>
 {selectedEvent.program.split('\n').map((line, index) => (
 <p key={index} className="mb-2" style={{ lineHeight: '1.8' }}>
 <i className="fa fa-check text-success me-2"></i>{line}
 </p>
 ))}
 </div>
 </div>

 {selectedEvent.voldetails && (
 <div className="mb-4">
 <h5 className="fw-bold mb-3" style={{ color: '#2B4C7E' }}>
 <i className="fa fa-plane-departure me-2"></i>Détails du Vol
 </h5>
 <div className="p-3" style={{
 background: 'linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%)',
 borderRadius: '15px'
 }}>
 <p className="mb-0" style={{ lineHeight: '1.8' }}>{selectedEvent.voldetails}</p>
 </div>
 </div>
 )}

 <div className="row g-4 mb-4">
 <div className="col-md-6">
 <h5 className="fw-bold mb-3" style={{ color: '#2B4C7E' }}>
 <i className="fa fa-check-circle me-2"></i>Services Inclus
 </h5>
 <ul className="list-group" style={{ borderRadius: '15px', overflow: 'hidden' }}>
 {selectedEvent.includedServices.map((service, index) => (
 <li key={index} className="list-group-item border-0 mb-2" style={{
 background: 'linear-gradient(135deg, #d4edda 0%, #c3e6cb 100%)',
 borderRadius: '10px'
 }}>
 <i className="fa fa-check-circle text-success me-2"></i>
 {service}
 </li>
 ))}
 </ul>
 </div>
 <div className="col-md-6">
 <h5 className="fw-bold mb-3" style={{ color: '#2B4C7E' }}>
 <i className="fa fa-times-circle me-2"></i>Services Non Inclus
 </h5>
 <ul className="list-group" style={{ borderRadius: '15px', overflow: 'hidden' }}>
 {selectedEvent.excludedServices.map((service, index) => (
 <li key={index} className="list-group-item border-0 mb-2" style={{
 background: 'linear-gradient(135deg, #f8d7da 0%, #f5c6cb 100%)',
 borderRadius: '10px'
 }}>
 <i className="fa fa-times-circle text-danger me-2"></i>
 {service}
 </li>
 ))}
 </ul>
 </div>
 </div>
 </div>
 <div className="modal-footer" style={{ 
 borderTop: '2px solid #e9ecef',
 padding: '1.5rem 2rem'
 }}>
 <button
 type="button"
 className="btn btn-light px-4"
 onClick={closeModal}
 style={{ borderRadius: '10px' }}
 >
 Fermer
 </button>
 <HashLink
 to={selectedEvent?.isActive ?"/#res" :"#"}
 className={`btn px-4 ${selectedEvent?.isActive ?"text-white" :"text-muted"}`}
 style={{
 background: selectedEvent?.isActive ? 'linear-gradient(135deg, #2B4C7E 0%, #567ebb 100%)' : '#ced4da',
 borderRadius: '10px',
 boxShadow: selectedEvent?.isActive ? '0 4px 15px rgba(43,76,126,0.3)' : 'none',
 cursor: selectedEvent?.isActive ? 'pointer' : 'not-allowed',
 pointerEvents: selectedEvent?.isActive ? 'auto' : 'none',
 }}
 onClick={selectedEvent?.isActive ? closeModal : undefined}
 >
 <i className="fa fa-calendar-check me-2"></i>
 {selectedEvent?.isActive ? 'Réserver Maintenant' : 'Événement complet'}
 </HashLink>
 </div>
 </div>
 </div>
 </div>
 )}

 {/* Hero Header */}
 <LazyBg src="assets/img/banner-voyage-organise.png" className="container-fluid position-relative py-5 mb-5" style={{
 backgroundSize: 'cover',
 backgroundPosition: 'center',
 minHeight: '400px',
 display: 'flex',
 alignItems: 'center',
 justifyContent: 'center',
 overflow: 'hidden'
 }}>
 <div style={{
 position: 'absolute', top: 0, left: 0, width: '100%', height: '100%',
 backgroundColor: 'rgba(1, 34, 92, 0.4)', zIndex: 2
 }}></div>

 <div className="container position-relative" style={{ zIndex: 3 }}>
 <div className="row justify-content-center">
 <div className="col-lg-10 text-center">
 <h1 className="display-4 text-white fw-bold mb-3" style={{ textShadow: '0 2px 10px rgba(0,0,0,0.3)', fontFamily:"'Inter', sans-serif" }}>
 Nos voyages organisés
 </h1>
 <p className="text-white fs-4 mb-0" style={{ textShadow: '0 2px 10px rgba(0,0,0,0.3)', fontFamily:"'Inter', sans-serif" }}>
 Découvrez des destinations extraordinaires
 </p>
 </div>
 </div>
 </div>
 </LazyBg>

 
 {/* Voyage Events Section */}
 <div className="container-fluid py-5" style={{minHeight: '100vh', fontFamily:"'Inter', sans-serif" }} id="results-section-voyage">
 <div className="container">
 <div className="row g-4">


 {/* Sidebar Filters */}
 <div className="col-lg-3 col-xl-3 d-none d-lg-block" id="desktop-filters">
 <div className="bg-white" style={{ borderRadius: '12px', overflow: 'hidden', border: '1px solid #DEE2E6', position: 'sticky', top: '100px' }}>
 <div className="text-white text-center py-2" style={{ backgroundColor: '#01225D' }}>
 <h4 className="mb-0" style={{ fontSize: '20px', fontWeight: 600, fontFamily:"'Inter', sans-serif" , color: 'white' }}>Filters</h4>
 </div>
 <div className="p-3 bg-white filter-scrollable">
 {/* Nom Filter */}
 <div className="mb-3">
 <label className="mb-2" style={{ color: '#00338C', fontSize: '15px', fontWeight: 600, fontFamily:"'Inter', sans-serif" }}>Nom</label>
 <div className="input-group bg-white" style={{ borderRadius: '6px', overflow: 'hidden', border: '1px solid #DEE2E6' }}>
 <input
 type="text"
 className="form-control border-0 shadow-none text-muted"
 placeholder="Nom du circuit"
 value={searchTerm}
 onChange={(e) => setSearchTerm(e.target.value)}
 style={{ fontSize: '14px', padding: '0.45rem 0.85rem' }}
 />
 <span className="input-group-text bg-white border-0" style={{ color: '#adb5bd' }}>
 <i className="fa fa-search"></i>
 </span>
 </div>
 </div>

 <div style={{ height: '1px', backgroundColor: '#37454D', opacity: 0.15, margin: '1.1rem 0.5rem' }}></div>

 {/* Destinations Filter */}
 <div className="mb-3">
 <label className="mb-3" style={{ color: '#00338C', fontSize: '15px', fontWeight: 600, fontFamily:"'Inter', sans-serif" }}>Destinations</label>
 <div className="d-flex flex-column gap-2">
 {destinations.map((dest, idx) => (
 <div className="form-check cursor-pointer" key={idx} style={{ display: 'flex', alignItems: 'center' }}>
 <input 
 className="form-check-input" 
 type="checkbox" 
 id={`dest-${idx}`} 
 checked={selectedDestinations.includes(dest)}
 onChange={() => handleDestinationToggle(dest)}
 style={{ width: '16px', height: '16px', flexShrink: 0, border: '1.5px solid #9BA2A6', cursor: 'pointer', marginTop: 0, borderRadius: '4px' }}
 />
 <label className="form-check-label ms-2" htmlFor={`dest-${idx}`} style={{ color: '#01225C', fontWeight: '500', fontSize: '14px', fontFamily:"'Inter', sans-serif", cursor: 'pointer' }}>
 {dest}
 </label>
 </div>
 ))}
 </div>
 </div>

 <div style={{ height: '1px', backgroundColor: '#37454D', opacity: 0.15, margin: '1.1rem 0.5rem' }}></div>

 {/* Price Filter */}
 <div className="mb-2">
 <label className="mb-3" style={{ color: '#00338C', fontSize: '15px', fontWeight: 600, fontFamily:"'Inter', sans-serif" }}>Prix par personne</label>

 <div style={{ position: 'relative', width: '100%', padding: '15px 0' }}>
 <style dangerouslySetInnerHTML={{__html: `
 @font-face {
 font-family: 'Playfair Display';
 src: url('/assets/fonts/Playfair_Display/PlayfairDisplay-VariableFont_wght.ttf') format('truetype');
 font-weight: 100 900;
 font-style: normal;
 }
 .filter-scrollable {
 max-height: calc(100vh - 170px);
 overflow-y: auto;
 }
 .filter-scrollable::-webkit-scrollbar {
 width: 6px;
 }
 .filter-scrollable::-webkit-scrollbar-track {
 background: #f1f3f5;
 border-radius: 8px;
 }
 .filter-scrollable::-webkit-scrollbar-thumb {
 background: #01225D;
 border-radius: 8px;
 }
 .filter-scrollable::-webkit-scrollbar-thumb:hover {
 background: #00338C;
 }
 .range-wrap { position: relative; width: 100%; height: 4px; background: #e9ecef; border-radius: 4px; }
 .range-fill { position: absolute; height: 100%; background: #FFBC1E; z-index: 1; }
 .dual-range { position: absolute; top: 50%; width: 100%; transform: translateY(-50%); z-index: 2; pointer-events: none; margin: 0; appearance: none; background: transparent; }
 .dual-range::-webkit-slider-thumb {
 pointer-events: auto;
 appearance: none;
 width: 24px;
 height: 24px;
 background: #fff;
 border: 6px solid #00338C;
 border-radius: 50%;
 cursor: pointer;
 }
 `}} />
 <div className="range-wrap">
 <div className="range-fill" style={{ left: `${(priceMin/15000)*100}%`, right: `${100 - (priceMax/15000)*100}%` }}></div>
 <input type="range" className="dual-range" min="0" max="15000" step="100" value={priceMin} onChange={e => setPriceMin(Math.min(Number(e.target.value), priceMax - 100))} />
 <input type="range" className="dual-range" min="0" max="15000" step="100" value={priceMax} onChange={e => setPriceMax(Math.max(Number(e.target.value), priceMin + 100))} />
 </div>
 </div>
 <div className="d-flex justify-content-between mt-3" style={{ fontSize: '13px', color: '#00338C', fontWeight: 600, fontFamily:"'Inter', sans-serif" }}>
 <span>{priceMin} TND</span>
 <span>{priceMax} TND</span>
 </div>
 </div>
 </div>
 </div>
 </div>

 {/* List Content */}


 
{/* ======= FLOATING MOBILE FILTER BUTTON ======= */}
<div 
 className="d-lg-none d-flex justify-content-center w-100" 
 style={{
 position: 'fixed',
 bottom: '30px',
 left: '0',
 zIndex: 1040,
 pointerEvents: 'none'
 }}
>
 <button
 className="btn d-flex align-items-center justify-content-center" 
 type="button"
 data-bs-toggle="offcanvas"
 data-bs-target="#mobileFilters"
 aria-controls="mobileFilters"
 style={{
 backgroundColor: 'rgba(1, 34, 93, 0.95)',
 color: 'white',
 fontWeight: '600',
 borderRadius: '50px',
 padding: '14px 32px',
 fontSize: '16px',
 fontFamily:"'Inter', sans-serif",
 boxShadow: '0 10px 30px rgba(1, 34, 93, 0.4)',
 border: '1px solid rgba(255, 255, 255, 0.15)',
 backdropFilter: 'blur(10px)',
 WebkitBackdropFilter: 'blur(10px)',
 pointerEvents: 'auto',
 letterSpacing: '0.5px',
 transition: 'transform 0.2s ease, box-shadow 0.2s ease'
 }}
 >
 <i className="fa fa-sliders-h me-2" style={{ fontSize: '18px' }}></i> Filtres
 </button>
</div>

<div 
 className="offcanvas offcanvas-end" 
 tabIndex="-1" 
 id="mobileFilters" 
 aria-labelledby="mobileFiltersLabel"
 style={{ borderLeft: 'none', boxShadow: '-10px 0 30px rgba(0,0,0,0.1)', maxWidth: '85vw', width: '360px', transition: 'transform 0.4s cubic-bezier(0.2, 0.8, 0.2, 1)' }}
>
 <div className="offcanvas-header bg-white" style={{ padding: '1.5rem 1.5rem 1rem 1.5rem', borderBottom: '1px solid rgba(0,0,0,0.05)', zIndex: 10 }}>
 <h5 className="offcanvas-title" id="mobileFiltersLabel" style={{ color: '#01225D', fontWeight: 800, fontSize: '22px', fontFamily:"'Inter', sans-serif" , letterSpacing: '-0.5px' }}>Filtres de voyage</h5>
 <button type="button" className="btn-close shadow-none" data-bs-dismiss="offcanvas" aria-label="Close" style={{ opacity: 0.6 }}></button>
 </div>
 {/* Remove 'filter-scrollable' on mobile so it doesn't get cropped by desktop max-height */}
 <div className="offcanvas-body p-4 bg-white overflow-auto flex-grow-1" style={{ paddingBottom: '100px' }}>
 
 {/* Nom Filter (Mobile) */}
 <div className="mb-4">
 <label className="mb-3" style={{ color: '#00338C', fontSize: '18px', fontWeight: 600, fontFamily:"'Inter', sans-serif" }}>Nom</label>
 <div className="input-group bg-white" style={{ borderRadius: '6px', overflow: 'hidden', border: '1px solid #DEE2E6' }}>
 <input
 type="text"
 className="form-control border-0 shadow-none text-muted"
 placeholder="Nom du circuit"
 value={searchTerm}
 onChange={(e) => setSearchTerm(e.target.value)}
 style={{ fontSize: '16px', padding: '0.6rem 1rem' }}
 />
 <span className="input-group-text bg-white border-0" style={{ color: '#adb5bd' }}>
 <i className="fa fa-search"></i>
 </span>
 </div>
 </div>

 <div style={{ height: '1px', backgroundColor: '#37454D', opacity: 0.15, margin: '1.5rem 0' }}></div>

 {/* Destinations Filter (Mobile) */}
 <div className="mb-4">
 <label className="mb-4" style={{ color: '#00338C', fontSize: '18px', fontWeight: 600, fontFamily:"'Inter', sans-serif" }}>Destinations</label>
 <div className="d-flex flex-column gap-3">
 {destinations.map((dest, idx) => (
 <div className="form-check cursor-pointer" key={`mob-dest-${idx}`} style={{ display: 'flex', alignItems: 'center' }}>
 <input
 className="form-check-input"
 type="checkbox"
 id={`mob-dest-${idx}`}
 checked={selectedDestinations.includes(dest)}
 onChange={() => handleDestinationToggle(dest)}
 style={{ width: '18px', height: '18px', flexShrink: 0, border: '1.5px solid #9BA2A6', cursor: 'pointer', marginTop: 0, borderRadius: '4px' }}
 />
 <label className="form-check-label ms-3" htmlFor={`mob-dest-${idx}`} style={{ color: '#01225C', fontWeight: '500', fontSize: '16px', fontFamily:"'Inter', sans-serif", cursor: 'pointer' }}>
 {dest}
 </label>
 </div>
 ))}
 </div>
 </div>

 <div style={{ height: '1px', backgroundColor: '#37454D', opacity: 0.15, margin: '1.5rem 0' }}></div>

 {/* Price Filter (Mobile) */}
 <div className="mb-5">
 <label className="mb-4" style={{ color: '#00338C', fontSize: '18px', fontWeight: 600, fontFamily:"'Inter', sans-serif" }}>Prix par personne</label>
 <div style={{ position: 'relative', width: '100%', padding: '15px 0' }}>
 <div className="range-wrap">
 <div className="range-fill" style={{ left: `${(priceMin/15000)*100}%`, right: `${100 - (priceMax/15000)*100}%` }}></div>
 <input type="range" className="dual-range" min="0" max="15000" step="100" value={priceMin} onChange={e => setPriceMin(Math.min(Number(e.target.value), priceMax - 100))} />
 <input type="range" className="dual-range" min="0" max="15000" step="100" value={priceMax} onChange={e => setPriceMax(Math.max(Number(e.target.value), priceMin + 100))} />
 </div>
 </div>
 <div className="d-flex justify-content-between mt-3" style={{ fontSize: '13px', color: '#00338C', fontWeight: 600, fontFamily:"'Inter', sans-serif" }}>
 <span>{priceMin} TND</span>
 <span>{priceMax} TND</span>
 </div>
 </div>

 {/* Réinitialiser button for mobile purely optional but nice to have */}
 <div className="mt-4">
 <button
 type="button"
 className="btn w-100 mb-3"
 style={{
 background: 'linear-gradient(135deg, #01225D 0%, #1e3a5f 100%)',
 color: 'white',
 padding: '14px',
 borderRadius: '12px',
 fontWeight: 'bold',
 border: 'none',
 boxShadow: '0 4px 15px rgba(1, 34, 93, 0.3)'
 }}
 data-bs-dismiss="offcanvas"
 onClick={() => {
 const resultsEl = document.getElementById('results-section-voyage');
 if (resultsEl) {
 const y = resultsEl.getBoundingClientRect().top + window.scrollY - 100;
 window.scrollTo({ top: y, behavior: 'smooth' });
 }
 }}
 >
 Voir les résultats ({filteredEvents.length})
 </button>

 <button 
 className="btn w-100 py-3" 
 onClick={() => {
 setSearchTerm('');
 setSelectedDestinations([]);
 setPriceMin(0);
 setPriceMax(15000);
 setTimeout(() => {
 const resultsEl = document.getElementById('results-section-voyage');
 if (resultsEl) {
 const y = resultsEl.getBoundingClientRect().top + window.scrollY - 100;
 window.scrollTo({ top: y, behavior: 'smooth' });
 }
 }, 100);
 }}
 style={{
 border: '1px solid #01225D',
 color: '#01225D',
 borderRadius: '12px',
 fontWeight: 'bold',
 background: 'transparent'
 }}
 data-bs-dismiss="offcanvas"
 >
 Réinitialiser les filtres
 </button>
 </div>

 </div>
</div>
{/* ============================================== */}

<div className="col-lg-9 col-xl-9">

 {loading ? (
 <div className="text-center py-5">
 <div className="spinner-border" style={{ color: '#01225C' }} role="status">
 <span className="visually-hidden">Chargement...</span>
 </div>
 </div>
 ) : filteredEvents.length === 0 ? (
 <div className="text-center py-5 bg-white border" style={{ borderRadius: '8px' }}>
 <p className="text-muted mb-0">Aucun voyage ne correspond à vos critères.</p>
 </div>
 ) : (
 <div className="d-flex flex-column gap-4">
 {filteredEvents.map((event) => {
 const pricing = getEventPricing(event);
 const basePrice = pricing.price || 0;
 return (
 <div key={event._id} className="card border bg-white" style={{ borderRadius: '12px', borderColor: '#e9ecef', overflow: 'hidden' }}>
 <div className="row g-0">
 {/* Image part */}
 <div className="col-md-4">
 <img
 src={event.image ||"assets/img/dest1.jpg"} 
 alt={event.title}
 className="img-fluid w-100 h-100"
 style={{ objectFit: 'cover', minHeight: '220px' }}
 />
 </div>

 {/* Details part */}
 <div className="col-md-5 d-flex flex-column px-4 py-3 justify-content-center">
 <h3 className="fw-bold mb-2" style={{ color: '#01225D', fontFamily:"'Playfair Display', serif", fontSize: '28px', letterSpacing: '0.5px' }}>{event.title}</h3>
 <p className="fw-bold mb-3" style={{ fontSize: '15px', color: '#01225D' }}>
 {event.destination}
 </p>

 {event.departureDates && event.departureDates.length > 0 ? (
 <div className="mb-3" style={{ fontSize: '13px', color: '#01225D', lineHeight: '1.8', fontWeight: '500' }}>
 <div>Date de Départ : {new Date(event.departureDates[0].departureDate).toLocaleDateString('fr-FR')}</div>
 <div>Date de Retour : {new Date(event.departureDates[0].returnDate).toLocaleDateString('fr-FR')}</div>
 </div>
 ) : (
 <div className="mb-3" style={{ fontSize: '13px', color: '#01225D', fontWeight: '500' }}>
 2 Départs disponibles
 </div>
 )}

 <div>
 <p className="mb-2 fw-bold" style={{ fontSize: '14px', color: '#01225D' }}>Votre Voyage Inclut</p>
 <div className="d-flex gap-3" style={{ color: '#FFBC1E', fontSize: '1.2rem' }}>
 <i className="fa fa-plane"></i>
 <i className="fa fa-suitcase"></i>
 <i className="fa fa-car"></i>
 <i className="fa fa-map-marked-alt"></i> 
 </div>
 </div>
 </div>

 {/* Price & Action part */}
 <div className="col-md-3 d-flex flex-column align-items-center justify-content-center px-4 py-3" style={{ borderLeft: '1px solid #e9ecef' }}>
 <div className="text-start w-100 mb-3">
 <span className="text-muted d-block mb-1" style={{ fontSize: '13px', fontWeight: '500' }}>À partir de</span>
 <h3 className="fw-bold mb-0" style={{ color: '#00338C', fontSize: '28px', fontFamily:"'Inter', sans-serif" }}>
 {basePrice > 0 ? `${basePrice} TND` :"Sur demande"}
 </h3>
 </div>

 <div className="d-flex flex-column w-100 gap-2"> 
 {event.pdfUrl ? (
 <a
 href={event.pdfUrl}
 target="_blank"
 rel="noreferrer"
 className="btn fw-bold w-100"
 style={{
 border: '1px solid #00338C',
 color: '#00338C',
 backgroundColor: 'white',
 padding: '8px 0',
 borderRadius: '8px',
 fontSize: '14px',
 textDecoration: 'none'
 }}
 >
 <i className="fa fa-file-pdf me-1"></i> Télécharger PDF
 </a>
 ) : (
 <button
 className="btn fw-bold w-100"
 disabled
 style={{
 border: '1px solid #dee2e6',
 color: '#adb5bd',
 backgroundColor: 'white',
 padding: '8px 0',
 borderRadius: '8px',
 fontSize: '14px',
 cursor: 'not-allowed'
 }}
 >
 <i className="fa fa-file-pdf me-1"></i> PDF non disponible
 </button>
 )}
 <button
 className="btn fw-bold w-100"
 style={{
 backgroundColor: '#002B7F',
 color: 'white',
 padding: '8px 0',
 borderRadius: '8px',
 fontSize: '14px'
 }}
 onClick={() => navigate(`/voyage/${event._id}`)}
 >
 Voir plus
 </button>
 </div>
 </div>
 </div>
 </div>
 );
 })}
 </div>
 )}
 </div>
 </div>
 </div>
 </div>
 </div>
 );
}


export default Voyage;